import './Compass';
import './style.css';
import Footer from '../Footer';
import * as Cesium from 'cesium';
import Toolbar from '../Toolbar';
import Chart from "components/Chart";
import styled from 'styled-components';
import CompareSlider from '../CompareSlider';
import { useAuth0 } from "@auth0/auth0-react";
import ApiInterface from 'utils/ApiInterface';
import { CollectionCategoryEnum } from 'Enums';
import StacInterface from "utils/StacInterface";
import UpgradeModal from "components/UpgradeModal";
import { TILESAPI_BASE_URL } from "utils/base_urls";
import { useDispatch, useSelector } from 'react-redux';
import useViewerStore from '../../store-zustand/viewer';
import StreetviewModal from 'components/StreetviewModal';
import StreetviewViewer from 'components/StreetviewViewer';
import React, { useEffect, useRef, useState } from 'react';
import { getLayerCollectionDetail } from '@/utils/helpers';
import { mouseMoveAction, getCameraFocus, enableTiltCesium, getBBOX, getGlobePositionWithTerrain } from './MapUtils';

window.CESIUM_BASE_URL = "/static/Cesium/";
Cesium.Ion.defaultAccessToken =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJmMjQxODJiYS0zMGUwLTRlMDAtOWE4OS0yOTAzOTliNzU1MzQiLCJpZCI6MTEzNDUsInNjb3BlcyI6WyJhc2wiLCJhc3IiLCJhc3ciLCJnYyJdLCJpYXQiOjE1NjAxMjU2MzR9.tGfAfbLfDgKcqARk_nKDpRPIfV9YnXrY6tC4hAsYqFg";

const Wrapper = styled.div`
  position: relative;
  flex: 1 1 auto;
`;

const FooterWrapper = styled.div`
  position: absolute;
  bottom: 0px;
  width: 100%;  
`;

const MapView = () => {
  const { setcurrentBBOX, setViewer } = useViewerStore();
  const compareTool = useSelector(state => state.settings.compareTool);
  const maxLevel = useSelector(state => state.settings.maxLevel);
  const showChart = useSelector(state => state.settings.showChart);
  const selectedMission = useSelector(state => state.asset.selectedMission);
  const [cesiumViewer, setCesiumViewer] = useState();
  const [pickedPoint, setPickedPoint] = useState(null);
  const [footerLocationData, setFooterLocationData] = useState();
  const [isImageryLoading, setIsImageryLoading] = useState(false);
  const [selectedStreetview, setSelectedStreetview] = useState();
  const [upgradeModalIsOpen, setUpgradeModalIsOpen] = useState(false);
  const [footerMissionDates, setFooterMissionDates] = useState();
  const maxZoomLevel = useRef(22);
  const userPlan = useRef('freemium');
  const mouseHandlerRef = useRef(null);
  const pendingFooterLocationRef = useRef(null);
  const footerLocationLastUpdateRef = useRef(0);
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  
  const FOOTER_LOCATION_THROTTLE_MS = 150;
  let current_centre_point = '0,0';
  
  const sortCollections = (collections) => {
    const custom_order = ["Imagery", "web-service", "Oblique", "Panorama", "DSM", "DEM"];
    collections.sort((a, b) => {
      const a_key = a.name;
      const b_key = b.name;

      const getGroupIndex = (key) => {
        for (let i = 0; i < custom_order.length; i++) {
          if (key.includes(custom_order[i])) {
            return i;
          }
        }
        return custom_order.length;
      }

      const a_index = getGroupIndex(a_key);
      const b_index = getGroupIndex(b_key);

      return a_index - b_index;
    });
    
    return collections;
  }

  const flushFooterLocation = () => {
    if (pendingFooterLocationRef.current !== undefined) {
      setFooterLocationData(pendingFooterLocationRef.current);
    }
  };

  const syncMapBBox = () => {
    var position = getCameraFocus(cesiumViewer);
    if (position === undefined) return;
    let bbox = getBBOX(cesiumViewer);
    if (bbox[0] !== "-180.0000" && bbox[1] !== "180.0000") {
      setcurrentBBOX(bbox);
    }
  }

  const onCameraMoveEnd = () => {
    flushFooterLocation();
    syncMapBBox();
  }

  const getImageryLayersAtPoint = () => {
    var camera_focus = getCameraFocus(cesiumViewer);
    if (camera_focus) {
      var carto_camera_focus = Cesium.Ellipsoid.WGS84.cartesianToCartographic(camera_focus);
      var lon = carto_camera_focus.longitude * Cesium.Math.DEGREES_PER_RADIAN;
      var lat = carto_camera_focus.latitude * Cesium.Math.DEGREES_PER_RADIAN;
      lon = Number(lon.toFixed(5))
      lat = Number(lat.toFixed(5))

      if (`${lon},${lat}` === current_centre_point) return;
      current_centre_point = `${lon},${lat}`;

      dispatch({ type: 'SET_OBLIQUE_AVAILABLE', obliqueAvailable: false });
      StacInterface.instance.getTmsLayersAtPoint(lon, lat).then((response) => {
        let dates = [];
        let obliquesAvailable = {};
        Object.keys(response.data).map(layer => {
          let [, collection] = getLayerCollectionDetail(layer);
     
          if (collection.category !== CollectionCategoryEnum.oblique_photo_tileset && collection.category !== CollectionCategoryEnum.oblique_photo_mosaic)
            dates.push({ [layer]: response.data[layer] });

          if (collection.category === CollectionCategoryEnum.oblique_photo_tileset || collection.category === CollectionCategoryEnum.oblique_photo_mosaic)
            obliquesAvailable[`Oblique:${layer.split(':')[1]}`] = response.data[layer];

          return null;
        });

        if (Object.keys(obliquesAvailable).length !== 0) {
          Object.keys(obliquesAvailable).forEach(layer => dates.push({ [layer]: obliquesAvailable[layer] }));

          dispatch({ type: 'SET_OBLIQUE_AVAILABLE', obliqueAvailable: true });
          StacInterface.instance.getObliqueTmsLayersAtPoint(lon, lat).then((response) => {
            dispatch({ type: 'SET_OBLIQUE_ASSETS', obliqueAssets: response.data });
          });
        }
        
        setFooterMissionDates(dates);
      })
    }

    if ((userPlan.current === null || userPlan.current === 'freemium') && cesiumViewer.camera.getMagnitude() < 6366100) {
      setUpgradeModalIsOpen(true);
    }
  }

  const checkImageryLoadProgress = () => {
    var loading = false;
    cesiumViewer.scene.globe._surface._tileLoadQueueLow.forEach(queue =>
      queue?.data?.imagery.forEach(imagery => {
        if (imagery.readyImagery?.level >= 17) {
          if (imagery.readyImagery?.imageryLayer?.imageryProvider?.url?.startsWith(TILESAPI_BASE_URL)) {
            loading = true;
          }
        }
      })
    );

    cesiumViewer.scene.globe._surface._tileLoadQueueMedium.forEach(queue =>
      queue?.data?.imagery.forEach(imagery => {
        if (imagery.readyImagery?.level >= 17) {
          if (imagery.readyImagery?.imageryLayer?.imageryProvider?.url?.startsWith(TILESAPI_BASE_URL)) {
            loading = true;
          }
        }
      })
    );

    cesiumViewer.scene.globe._surface._tileLoadQueueHigh.forEach(queue =>
      queue?.data?.imagery.forEach(imagery => {
        if (imagery.readyImagery?.level >= 17) {
          if (imagery.readyImagery?.imageryLayer?.imageryProvider?.url?.startsWith(TILESAPI_BASE_URL)) {
            loading = true;
          }
        }
      })
    );

    var maxZoom = 10;
    cesiumViewer.scene.globe._surface._tilesToRender.forEach(tile => {
      tile.data.imagery.forEach(tileImagery => {
        if (tileImagery.readyImagery?.imageryLayer?.imageryProvider?.url?.startsWith(TILESAPI_BASE_URL)) {
          maxZoom = tile.level;
        }
      });
    });

    cesiumViewer.dataSources._dataSources.map(source => {
      if (source.show) {
        maxZoom = maxZoomLevel.current;
      }
      return null;
    });

    dispatch({ type: "SET_MAX_LEVEL", maxLevel: maxZoom })
    setIsImageryLoading(loading);
  }

  const updateStreetviewTilesetPointSize = (tileset) => {
    const minPointSize = 2.0;
    const maxPointSize = 15.0;
    const minHeight = 200.0;
    const maxHeight = 10000.0;
    const cameraHeight = cesiumViewer.camera.positionCartographic.height;
    
    let t = (cameraHeight - minHeight) / (maxHeight - minHeight);
    t = Math.max(0.0, Math.min(1.0, t));
    const pointSize = maxPointSize * (1.0 - t) + minPointSize * t;
    
    if (tileset.customShader && tileset.customShader.uniforms && tileset.customShader.uniforms.u_pointSize) {
      tileset.customShader.uniforms.u_pointSize.value = pointSize;
    }
  }

  const getTilesAPIAccessToken = async () => {
    try {
      const tilesAccessToken = await getAccessTokenSilently({
        audience: `https://tiles.fastmap.ai/docs`
      });
      console.log("tiles api token:", tilesAccessToken);
      localStorage.setItem("tiles_api_auth0_token", tilesAccessToken);
      return (tilesAccessToken);
    } catch (e) {
      return null;
    }
  };

  const setupMouseEventHandlers = (cesium_viewer) => {
    if (mouseHandlerRef.current) {
      mouseHandlerRef.current.destroy();
    }

    const handler = new Cesium.ScreenSpaceEventHandler(cesium_viewer.scene.canvas);
    handler.setInputAction((movement) => {
      pendingFooterLocationRef.current = mouseMoveAction(movement, cesium_viewer);
      const now = Date.now();
      if (now - footerLocationLastUpdateRef.current < FOOTER_LOCATION_THROTTLE_MS) {
        return;
      }
      footerLocationLastUpdateRef.current = now;
      setFooterLocationData(pendingFooterLocationRef.current);
    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    handler.setInputAction((movement) => {
      setPickedPoint(new Cesium.Cartesian2(movement.position.x, movement.position.y));
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    mouseHandlerRef.current = handler;
  };

  const setupTouchEventPrevention = (cesium_viewer) => {
    const canvas = cesium_viewer.scene.canvas;
    const wrapper = document.getElementById('cesium-wrapper');

    const preventBrowserTouchDefaults = (event) => {
      event.preventDefault();
    };

    canvas.addEventListener('touchmove', preventBrowserTouchDefaults, { passive: false });
    wrapper?.addEventListener('gesturestart', preventBrowserTouchDefaults, { passive: false });
    wrapper?.addEventListener('gesturechange', preventBrowserTouchDefaults, { passive: false });

    return () => {
      canvas.removeEventListener('touchmove', preventBrowserTouchDefaults);
      wrapper?.removeEventListener('gesturestart', preventBrowserTouchDefaults);
      wrapper?.removeEventListener('gesturechange', preventBrowserTouchDefaults);
    };
  }

  const setBaseMap = (cesium_viewer) => {
    if (cesium_viewer.imageryLayers.length !== 0) return;
    const mapbox_basemap = new Cesium.MapboxStyleImageryProvider({
      username: 'fastmap',
      styleId: 'ckoog99o80rqr17poritt9k6r',
      accessToken: 'pk.eyJ1IjoiZmFzdG1hcCIsImEiOiJja3pyYzM2NXo2aWFoMnlwcnlsMDh2aHd2In0.xp7hdZrsRhEJgXC7HHnpiw',
      tileSize: 512,
      maximumLevel: maxZoomLevel.current
    });

    cesium_viewer.imageryLayers.addImageryProvider(mapbox_basemap, 0);
    setCesiumViewer(cesiumViewer);
  }

  useEffect(() => {
    if (selectedMission === undefined || selectedMission === null) return;
    if (!(selectedMission in window.HDImagery)) return;
    if (selectedStreetview === undefined || selectedStreetview === null) return;

    if (window.HDImagery[selectedMission] && window.HDImagery[selectedMission]['rgb']) {
      const tileset = window.HDImagery[selectedMission]['rgb'];
      if (selectedStreetview?.uuid) {
        tileset.style = new Cesium.Cesium3DTileStyle({
          color: {
            conditions: [
              [`\${uuid} === '${selectedStreetview.uuid}'`, "color('#5cc76f', 0.75)"],
              ["true", "color('#55bcff', 0.75)"]
            ]
          }
        });
      } else {
        tileset.style = new Cesium.Cesium3DTileStyle({color: "color('#55bcff', 0.75)"});
      }

      if (selectedStreetview?.position) {
        cesiumViewer.camera.flyTo({
          destination: Cesium.Cartesian3.fromDegrees(
            selectedStreetview.position.longitude * (180 / Math.PI),
            selectedStreetview.position.latitude * (180 / Math.PI),
            200
          )
        });
      }
    }
  }, [selectedStreetview]);

  useEffect(() => {
    if (!cesiumViewer) return;
    
    const point = cesiumViewer.scene.pick(pickedPoint);
    if (Cesium.defined(point) && Cesium.defined(point.getProperty)) {
      let coordinates = getGlobePositionWithTerrain(cesiumViewer, pickedPoint);
      let streetviewAsset = {
        position: coordinates,
        uuid: point.getProperty('uuid'),
        mission_id: point.getProperty('mission_id'),
        layer_name: point.getProperty('layer_name'),
        capture_datetime: point.getProperty('capture_datetime'),
        view_azimuth_deg: point.getProperty('view_azimuth_deg')
      }
      setSelectedStreetview(streetviewAsset);
    } else {
      setSelectedStreetview();
    }
  }, [pickedPoint]);
  
  useEffect(() => {
    if (cesiumViewer === undefined) return;
    
    setBaseMap(cesiumViewer);
    setupTouchEventPrevention(cesiumViewer);
    setupMouseEventHandlers(cesiumViewer);
    enableTiltCesium(cesiumViewer, false);

    const controller = cesiumViewer.scene.screenSpaceCameraController;
    controller.enableTranslate = true;
    controller.enableZoom = true;
    controller.enableRotate = true;
    
    cesiumViewer.camera.moveEnd.addEventListener(onCameraMoveEnd);
    window.MAIN_CESIUM_VIEWER = cesiumViewer;
    window.Cesium = Cesium;
    window.Satellite = cesiumViewer.imageryLayers.get(0);
    window.HDImagery = {};
    window.ortho = true;
    window.cesiumWorldTerrain = Cesium.createWorldTerrainAsync({
      requestVertexNormals: true
    });
    cesiumViewer.camera.percentageChanged = 0.05;

    document.getElementById("compass").appendChild(document.createElement('cesium-compass'));
    setViewer(cesiumViewer);

    cesiumViewer.scene.globe.depthTestAgainstTerrain = true;
    window.MAIN_CESIUM_VIEWER.scene.globe.maximumScreenSpaceError = 1;
    cesiumViewer.scene.globe.tileLoadProgressEvent.addEventListener(checkImageryLoadProgress);

    var imageryPromises = [];
    getTilesAPIAccessToken().then(token => {
      StacInterface.instance.getExportableCollections().then(response => {
        window.exportable_collections = response.data
        StacInterface.instance.getDemonstrableCollections().then((response) => {
          window.demonstrable_collections = sortCollections(response.data);
          window.demonstrable_collections.push({
            "id": -1,
            "name": "Oblique",
            "parent_id": null,
            "parent": null,
            "is_demonstrable": true,
            "is_exportable": false,
            "category": 7,
            "default_bucket_name": "fm-tms",
            "cardinal_direction": 0
          });
          StacInterface.instance.getAllTmsLayer().then((response) => {
            window.style = {}
            Object.keys(response.data).forEach(mission => {
              window.HDImagery[mission] = {};
              let [, collection] = getLayerCollectionDetail(mission);
              if (collection.category === CollectionCategoryEnum.terrain_mosaic || collection.category === CollectionCategoryEnum.terrain_tileset) {
                ['schwarzwald', 'hillshade'].forEach((style) => {
                  window.HDImagery[mission][style] = cesiumViewer.imageryLayers.addImageryProvider(
                    new Cesium.UrlTemplateImageryProvider({
                      url: new Cesium.Resource({
                        url: `${TILESAPI_BASE_URL}/v2/OSG/TMS/${mission}/{z}/{x}/{y}?image_type=${style}&tilesize=512&minLevel=10&maxLevel=${maxZoomLevel.current}`,
                        headers: {
                          'Authorization': `Bearer ${token}`
                        },
                      }),
                      tileWidth: 512,
                      tileHeight: 512,
                      maximumLevel: maxZoomLevel.current
                    }), 1);
                  window.HDImagery[mission][style].show = false;
                  imageryPromises.push(window.HDImagery[mission][style].imageryProvider.readyPromise);
                });
                window.style.terrain = 'schwarzwald';
              } else if (collection.category === CollectionCategoryEnum.streetview) {
                ['rgb'].forEach((style) => {
                  Cesium.Cesium3DTileset.fromUrl(new Cesium.Resource({
                    url: `${TILESAPI_BASE_URL}/v2/OSG/3DVT/streetview/${mission}/tileset.json`,
                    headers: {
                      'Authorization': `Bearer ${token}`
                    },
                  })).then(tileset => {
                    tileset.customShader = new Cesium.CustomShader({
                      uniforms: {
                        u_pointSize: {
                          type: Cesium.UniformType.FLOAT,
                          value: 2,
                        },
                      },
                      vertexShaderText: `
                        void vertexMain(VertexInput vsInput, inout czm_modelVertexOutput vsOutput) {
                          vsOutput.positionMC += 0.1 * vsInput.attributes.normalMC;
                          vsOutput.pointSize = u_pointSize;
                        }
                      `,
                      fragmentShaderText: `
                        void fragmentMain(FragmentInput fsInput, inout czm_modelMaterial material) {
                          vec2 center = gl_PointCoord - vec2(0.5);
                          float dist = length(center);

                          float outer = step(dist, 0.5);
                          float inner = step(dist, 1.0/4.0);
                          if (outer < 0.5) {
                            discard;
                          }

                          vec3 blue = vec3(0.33, 0.73, 1.0);
                          float alpha = mix(0.75, 1.0, inner);

                          material.diffuse = blue;
                          material.alpha = alpha;
                        }
                      `
                    });

                    cesiumViewer.camera.changed.addEventListener(() => updateStreetviewTilesetPointSize(tileset));
                    updateStreetviewTilesetPointSize(tileset);
                    
                    tileset.style = new Cesium.Cesium3DTileStyle({color: "color('#55bcff', 0.75)"});
                    cesiumViewer.scene.primitives.add(tileset);
                    window.HDImagery[mission][style] = tileset;
                  }).catch(error => {
                    console.error('Error loading tileset:', error);
                  });
                });
              } else if (collection.category === CollectionCategoryEnum.ortho_photo_mosaic || collection.category === CollectionCategoryEnum.ortho_photo_tileset || collection.category === CollectionCategoryEnum.web_service) {
                ['rgb', 'nir', 'greyscale'].forEach((style) => {
                  window.HDImagery[mission][style] = cesiumViewer.imageryLayers.addImageryProvider(
                    new Cesium.UrlTemplateImageryProvider({
                      url: new Cesium.Resource({
                        url: `${TILESAPI_BASE_URL}/v2/OSG/TMS/${mission}/{z}/{x}/{y}?image_type=${style}&tilesize=512&minLevel=10&maxLevel=${maxZoomLevel.current}`,
                        headers: {
                          'Authorization': `Bearer ${token}`
                        },
                      }),
                      tileWidth: 512,
                      tileHeight: 512,
                      maximumLevel: maxZoomLevel.current
                    }), 1);
                  window.HDImagery[mission][style].show = false;
                  imageryPromises.push(window.HDImagery[mission][style].imageryProvider.readyPromise);
                });
                window.style.mosaic = 'rgb';
              }
            })
          }).then(() => {
            Promise.all(imageryPromises).then(() => {
              console.log("Layers are loaded.");
              cesiumViewer.camera.moveEnd.addEventListener(getImageryLayersAtPoint);
              getImageryLayersAtPoint();
            })
          })
        });
      });
    })

    return () => {
      cesiumViewer.camera.moveEnd.removeEventListener(onCameraMoveEnd);
      cesiumViewer.camera.moveEnd.removeEventListener(getImageryLayersAtPoint);
      mouseHandlerRef.current?.destroy();
      mouseHandlerRef.current = null;
    };
  }, [cesiumViewer]);

  useEffect(() => {
    if (cesiumViewer !== undefined) return;

    ApiInterface.instance.userProfile().then((profile) => {
      userPlan.current = profile.data?.metadata?.plan?.toLowerCase();
      if (userPlan.current === null || userPlan.current === 'freemium') {
        maxZoomLevel.current = 16;
      }
      
      setCesiumViewer(
        new Cesium.Viewer(
          'cesium-content', {
          baseLayerPicker: false,
          geocoder: false,
          sceneModePicker: false,
          homeButton: false,
          animation: false,
          infoBox: false,
          navigationHelpButton: false,
          fullscreenButton: false,
          useDefaultRenderLoop: true,
          timeline: false,
          selectionIndicator: false,
          imageryProvider: false
        })
      );
    })
  }, []);

  return (
    <Wrapper>
      {upgradeModalIsOpen && <UpgradeModal setIsOpen={setUpgradeModalIsOpen} templateName={'starter'} callOnClose={() => null} />}
      <span className="tooltipDrawing">
        <p className="tooltipDrawingtext"></p>
      </span>
      <div className={selectedStreetview !== undefined ? "viewer viewer-cesium-inspect" : "viewer viewer-cesium"} >
        <div id="cesium-wrapper" className={selectedStreetview !== undefined ? "viewer-cesium-content-wrapper viewer-cesium-inspect" : "viewer-cesium-content-wrapper"}>
          <div id="cesium-content" className={selectedStreetview !== undefined ? "viewer-cesium-content viewer-cesium-inspect" : "viewer-cesium-content"}>
          </div>
        </div>
        {cesiumViewer && compareTool && <CompareSlider missionDates={footerMissionDates} />}
        <iframe id="matterport-iframe" />
      </div>
      <FooterWrapper>
        <div style={{ position: 'relative' }}>
          <div className='compass' id="compass"></div>
          <Toolbar missionDates={footerMissionDates} />
        </div>
        {selectedStreetview && <StreetviewViewer selectedStreetview={selectedStreetview} setSelectedStreetview={setSelectedStreetview} />}
        {selectedStreetview && <StreetviewModal selectedStreetview={selectedStreetview} />}
        <Footer location={footerLocationData} missionDates={footerMissionDates} loading={isImageryLoading} maxLevel={maxLevel} />
      </FooterWrapper>
      {showChart && <Chart />}
    </Wrapper >
  );
}

export default MapView;